"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.savedCart = exports.viewCart = exports.resetCartCompleted = exports.resetCartCanceled = exports.resetCartStart = void 0;
const constants_1 = require("../constants");
const getCartProps = ({ cart, session }) => ({
    [constants_1.EventProperty.CART_PRODUCT_CATEGORIES]: cart.categories,
    [constants_1.EventProperty.CART_PRODUCT_IDS]: cart.ids,
    [constants_1.EventProperty.CART_PRODUCT_NAMES]: cart.names,
    [constants_1.EventProperty.CART_PRODUCT_SKUS]: cart.skus,
    [constants_1.EventProperty.CART_SIZE]: cart.size,
    [constants_1.EventProperty.CART_VALUE]: cart.value,
    [constants_1.EventProperty.CUSTOM_NOTE_TEXT]: cart.note,
    [constants_1.EventProperty.CUSTOMER_NAME]: session.customer,
    [constants_1.EventProperty.USER_ID]: session.userID,
    [constants_1.EventProperty.SESSION_ID]: session.sessionID
});
exports.resetCartStart = ({ cart, session }) => {
    const props = getCartProps({ cart, session });
    window.analytics.track(constants_1.EventName.RESET_CART_START, props);
};
exports.resetCartCanceled = ({ cart, session }) => {
    const props = getCartProps({ cart, session });
    window.analytics.track(constants_1.EventName.RESET_CART_CANCELED, props);
};
exports.resetCartCompleted = ({ cart, session }) => {
    const props = getCartProps({ cart, session });
    window.analytics.track(constants_1.EventName.RESET_CART_COMPLETED, props);
};
exports.viewCart = ({ cart, session }) => {
    const props = getCartProps({ cart, session });
    window.analytics.track(constants_1.EventName.CART_VIEWED, props);
};
exports.savedCart = ({ cart, session }) => {
    const props = getCartProps({ cart, session });
    window.analytics.track(constants_1.EventName.CART_SAVED, props);
};
